import { SPLIT_SHIPPED_ITEM_TYPE } from 'swag-common/constants/item-sources';
export const checkIsSplitShippedToInventory = item => {
  return item.splitShippedType === SPLIT_SHIPPED_ITEM_TYPE.toInventory;
};
export const checkIsSplitShippedToCustomer = item => {
  return item.splitShippedType === SPLIT_SHIPPED_ITEM_TYPE.toCustomer;
};
export const checkIsSplitShipped = item => {
  return checkIsSplitShippedToInventory(item) || checkIsSplitShippedToCustomer(item);
};